import { useMemo } from "react";
import {
	getPublicBrandingFaviconUrl,
	getPublicBrandingLogoMainUrl,
	getPublicBrandingLogoSmallUrl,
	resolvePublicBrandingMediaUrl,
} from "@Front/Api/helpers/publicApiUrls";
import { usePublicSiteConfigContext } from "@Front/Services/PublicSiteConfig/usePublicUiOptions";

export type PublicSiteBrandingAssets = {
	logoMainUrl: string;
	logoSmallUrl: string;
	faviconUrl: string;
};

function defaultBrandingAssets(): PublicSiteBrandingAssets {
	return {
		logoMainUrl: getPublicBrandingLogoMainUrl(),
		logoSmallUrl: getPublicBrandingLogoSmallUrl(),
		faviconUrl: getPublicBrandingFaviconUrl(),
	};
}

export function usePublicSiteBrandingAssets(): PublicSiteBrandingAssets {
	const { config } = usePublicSiteConfigContext();

	return useMemo(() => {
		const prev = defaultBrandingAssets();
		const branding = config?.branding;
		if (!branding) {
			return prev;
		}
		return {
			logoMainUrl: resolvePublicBrandingMediaUrl(branding.logo_main_url, prev.logoMainUrl),
			logoSmallUrl: resolvePublicBrandingMediaUrl(branding.logo_small_url, prev.logoSmallUrl),
			faviconUrl: resolvePublicBrandingMediaUrl(branding.favicon_url, prev.faviconUrl),
		};
	}, [config]);
}
